import React, { FC } from 'react';
import './spinner.scss';
import classNames from 'classnames';

interface SpinnerProps {
  isDisabled?: boolean;
  size?: number;
}

const Spinner: FC<SpinnerProps> = ({ isDisabled = false, size }) => {
  const dimensionInPx = size && `${size}px`;
  const marginInPx = size && `${-size / 2}px`;
  return (
    <svg
      className={classNames({
        spinner: true,
        'spinner--disabled': isDisabled,
      })}
      style={{
        width: dimensionInPx,
        height: dimensionInPx,
        marginTop: marginInPx,
        marginLeft: marginInPx,
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      height="50"
      width="50">
      <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
    </svg>
  );
};

export default Spinner;
